import { buildColor } from "@tvg/design-system";
import styled, { css } from "styled-components";
import { ScrollableTable, CellProps } from "./types";
import { TableColumns } from "../types";

export const Wrapper = styled.div<{
  hasScrolled?: boolean;
}>`
  display: flex;
  overflow: auto;
  z-index: 0;
  ${({ hasScrolled }) =>
    hasScrolled &&
    css`
      & > div:first-of-type {
        box-shadow: 0 1px 16px 0 rgba(17, 43, 68, 0.25);
      }
    `}
`;

export const Column = styled.div<
  ScrollableTable & Omit<TableColumns, "dataKey">
>`
  position: ${({ isFixed }) => (isFixed ? "sticky" : "relative")};
  left: 0;
  max-width: ${({ width }) => width && `${width}px`};
  min-width: ${({ width, isScrollable }) =>
    isScrollable && (width ? `${width}px` : "70.25px")};
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "900")};
  z-index: ${({ isFixed }) => (isFixed ? "2" : "1")};
  transition: box-shadow 0.2s ease-in-out;
  flex: 1;
`;

export const Cell = styled.div<CellProps>`
  padding: ${({ isEmptyCorner }) => !isEmptyCorner && "12px"};
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-style: solid;
  border-color: ${buildColor("blue", "100")};
  border-bottom-width: ${({ isEmptyCorner }) => !isEmptyCorner && "1px"};
  border-right-width: ${({ isEmptyCorner, isFixed }) =>
    !isEmptyCorner && isFixed && "1px"};
  font-family: Roboto-regular, sans-serif; ;
`;
